var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('p',{staticClass:"font-weight-light",staticStyle:{"font-size":"25px"}},[_vm._v(_vm._s(_vm.score.scoreStudent)+" EXP")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }